export default __webpack_public_path__ + "static/home-6c9113b5af635a260cb476a039d2943a.png";